import { motion } from 'framer-motion';

const differentiators = [
  {
    title: 'Long-Horizon Intelligence',
    desc: 'We design systems and strategies built to endure volatility, regulatory change, and technological evolution — not just the current quarter.',
  },
  {
    title: 'Enterprise AI Transformation',
    desc: 'We help organisations evolve structurally toward AI-native operations — through diagnostics, architecture, and measured implementation.',
  },
  {
    title: 'Future-Ready Systems Architecture',
    desc: 'Every engagement produces governance-grade frameworks, decision architectures, and intelligence systems designed for long-term institutional use.',
  },
  {
    title: 'Selective Institutional Engagement',
    desc: 'We work with a small number of serious counterparts. Every engagement is private, confidential, and tailored to the organisation.',
  },
];

const WhyCelestialMinds = () => {
  return (
    <section className="relative py-16 lg:py-20" data-testid="why-celestial-minds">
      <div className="section-divider mb-16" />
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <p className="text-xs uppercase tracking-[0.3em] mb-3" style={{ color: 'rgba(201,162,39,0.5)' }}>
            Differentiation
          </p>
          <h3
            className="text-xl md:text-2xl font-light tracking-[0.1em] text-white"
            style={{ fontFamily: "'Cinzel', serif" }}
          >
            Why Celestial Minds&#8482;
          </h3>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {differentiators.map((d, i) => (
            <motion.div
              key={d.title}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="p-6 text-center"
              style={{
                background: 'rgba(10,22,40,0.35)',
                border: '1px solid rgba(201,162,39,0.1)',
                borderRadius: '4px',
              }}
              data-testid={`differentiator-${i + 1}`}
            >
              <h4
                className="text-xs uppercase tracking-[0.15em] mb-3"
                style={{ color: '#c9a227', fontFamily: "'Cinzel', serif" }}
              >
                {d.title}
              </h4>
              <p className="text-sm leading-relaxed" style={{ color: 'rgba(255,255,255,0.5)' }}>
                {d.desc}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyCelestialMinds;
